var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"confirm-text"},[_vm._v(_vm._s(_vm.msg))]),_c('div',{staticClass:"wy-btn-boder"},[_c('div',{staticClass:"wy-sure",on:{"click":_vm.sure}},[_vm._v(_vm._s(_vm.$t('message.qd')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }